// extracted by mini-css-extract-plugin
export default {"card":"AdvantagesCard_card__qSCAD","card__title":"AdvantagesCard_card__title__rJWoi","card__text":"AdvantagesCard_card__text__BQxoV"};